// Mağaza listesi kaynak linkleri (birden fazla, değiştirilebilir)
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Link2, Plus, Trash2, Check } from 'lucide-react';
import { confirmDialog } from '../ConfirmHost';
import { API, errText, dt } from './storeShared';

const LocSelect = ({ value, onChange, locations, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-48" data-testid={testId}><SelectValue placeholder="Lokasyon" /></SelectTrigger>
    <SelectContent>{locations.map(l => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}</SelectContent>
  </Select>
);

const Row = ({ s, locations, onChanged }) => {
  const [f, setF] = useState({ url: s.url, location_id: s.location_id, label: s.label || '' });
  const dirty = f.url !== s.url || f.location_id !== s.location_id || f.label !== (s.label || '');
  const save = async () => { try { await axios.put(`${API}/stores/sources/${s.id}`, f); toast.success('Kaynak güncellendi'); onChanged(); } catch (e) { toast.error(errText(e)); } };
  const del = async () => {
    if (!(await confirmDialog({ title: 'Kaynak silinsin mi?', description: 'Bu linkten gelen mağazalar listede kalır, sadece senkron yapılmaz.', confirmLabel: 'Evet, Sil' }))) return;
    try { await axios.delete(`${API}/stores/sources/${s.id}`); onChanged(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="space-y-1 rounded-lg border p-3" data-testid={`store-source-${s.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <Input className="w-36" placeholder="Etiket" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} />
        <Input className="min-w-64 flex-1" value={f.url} onChange={(e) => setF({ ...f, url: e.target.value })} data-testid={`store-source-url-${s.id}`} />
        <LocSelect value={f.location_id} onChange={(v) => setF({ ...f, location_id: v })} locations={locations} />
        <Button size="icon" variant="ghost" className="text-emerald-600" disabled={!dirty} onClick={save} data-testid={`store-source-save-${s.id}`}><Check className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" className="text-rose-600" onClick={del} data-testid={`store-source-delete-${s.id}`}><Trash2 className="h-4 w-4" /></Button>
      </div>
      <p className="text-xs text-slate-400">{s.last_synced_at ? `Son senkron: ${dt(s.last_synced_at)}` : 'Henüz senkron yapılmadı'}</p>
    </div>
  );
};

export const StoreSourcesDialog = ({ open, onClose, locations }) => {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ url: '', location_id: '', label: '' });
  const load = () => axios.get(`${API}/stores/sources`).then(r => setList(r.data)).catch(() => {});
  useEffect(() => { if (open) load(); }, [open]);
  const add = async () => {
    try { await axios.post(`${API}/stores/sources`, f); setF({ url: '', location_id: '', label: '' }); toast.success('Kaynak eklendi'); load(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl" data-testid="store-sources-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Link2 className="h-5 w-5" />Mağaza Listesi Kaynakları</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">AVM web sitesindeki mağaza listesi sayfalarını ekleyin. Her link bir lokasyona bağlanır; senkronda mağaza adları ve varsa kat bilgileri çekilir.</p>
        <div className="flex flex-wrap items-center gap-2 rounded-lg bg-slate-50 p-3">
          <Input className="w-36" placeholder="Etiket (opsiyonel)" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} data-testid="store-source-new-label" />
          <Input className="min-w-64 flex-1" placeholder="https://www.ornek-avm.com/magazalar" value={f.url} onChange={(e) => setF({ ...f, url: e.target.value })} data-testid="store-source-new-url" />
          <LocSelect value={f.location_id} onChange={(v) => setF({ ...f, location_id: v })} locations={locations} testId="store-source-new-location" />
          <Button onClick={add} disabled={!f.url.trim() || !f.location_id} data-testid="store-source-add-btn"><Plus className="h-4 w-4 mr-1" />Ekle</Button>
        </div>
        <div className="max-h-96 space-y-2 overflow-y-auto">
          {list.length === 0 ? <p className="py-6 text-center text-sm text-slate-500">Henüz kaynak link eklenmedi.</p> : list.map(s => <Row key={s.id + s.url + s.location_id} s={s} locations={locations} onChanged={load} />)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
